import { Tour } from "nextstepjs";
import { getDeviceType } from "@/helpers/storeLocatorHelper";
const deviceType = getDeviceType();

const recipeListGuide: Tour[] = [
  {
    tour: "recipeListTour",
    steps: [
      {
        icon: "",
        title: "",
        content:
          "Create and save your recipe lists to keep all your favorite recipes in one place.",
        selector: "#create_new_recipeList",
        side: deviceType === "mobile" ? "top-left" : "bottom-left",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
      {
        icon: "",
        title: "",
        content: "Select recipe lists to delete, or merge them as needed.",
        selector: "#add_delete_merged_recipeList",
        side: deviceType === "mobile" ? "top-left" : "bottom",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default recipeListGuide;
